$bog_gamengine_demo_crumb_studio $bog_gamengine_studio
	title \Студия крошек
